import script from "./CropperCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CropperCard.vue?vue&type=script&setup=true&lang=js"

import "./CropperCard.vue?vue&type=style&index=0&id=131146be&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-131146be"]])

export default __exports__